import styled from './modalwhabol.module.css'
import { useContext, useEffect, useState } from 'react';
import {AuthContext} from '../../services/global';
import api from '../../services/api';
import {Alerta} from '../../utils/functions';
import InputMask from 'react-input-mask';

function ModalWhabol() {
    const {setIsOpenBol} = useContext(AuthContext);
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    const { whabol } = useContext(AuthContext);


    const [wats,setWats] = useState(whabol);
    
    function closeModal() {
        setIsOpenBol(false);
    }

    async function PutWhabol(){
        await api.post(`info/whabol?whabol=${wats}&cgccli=${cgccli}`)
        .then((response)=>{
             if(!response.data.errocod){
                 closeModal();
                 
                 Alerta('Sucesso','Alteração realizada com sucesso!','success');
             }else{
                closeModal(); 
                Alerta('Erro',response.data.errocod,'error')
             }
        }).catch((erro)=>{
            closeModal();
            Alerta('Erro',erro,'error')
        })
    }

    useEffect(()=>{
        
    },[])

     



    return (

            <div className={styled.modal}>
                <div className={styled.modalheader}>
                    <a>Recebimento de Boletos</a>
                    <div className={styled.cardtitleline}></div>
                </div>
                <div className={styled.modalcontent}>
                    <div className={styled.appmodal}>
                        <div className={styled.div1}>
                            <a>Numero</a>
                            <InputMask mask="(99)99999-9999" value={wats} onChange={(e)=>setWats(e.target.value)}></InputMask>
                        </div>
                    </div>

                </div>
                <div className={styled.modalfooter} onClick={()=>PutWhabol()}>
                    SALVAR
                </div>
            </div>
    )
}

export default ModalWhabol;